import Metrics from '@conv/metrics/lib/metrics-2.10.29.min.js';
import Fingerprint from '@conv/metrics/lib/fingerprint-2.10.29.min.js';
import { ENVIRONMENTS } from './constants/environments';
import { ServerEnvironment } from './api/config';

export let metrics;

export function InitialiseMetrics(sdkParams) {
	if (ENVIRONMENT === ENVIRONMENTS.DEVELOPMENT) {
		metrics = new Metrics();
		return;
	}

	const IDS_TO_TRACK_FOCUS = [
		'login-player-identifier-input',
		'page_login_always-visible_input_player-identifier',
		'login-password-input',
		'page_login_always-visible_input_password',
		'nickname-input',
		'password-input',
		'page_registration_step-one_input_password',
		'email-input',
		'page_registration_step-one_input_email',
		'terms-input'
	];

	metrics = new Metrics();
	try {
		metrics.init(
			{
				schemaVersion: '20251002121642',
				eventType: 'lps',
				systemType: 'conversion',
				systemName: 'metricsjs-frontend',
				gameId: sdkParams.gameId,
				marketId: sdkParams.marketId,
				partnerPrefix: sdkParams.partnerPrefix,
				campaignId: sdkParams.campaignId,
				bannerId: sdkParams.bannerId,
				creativeId: sdkParams.creativeId,
				publisherId: sdkParams.publisherId,
				metricsUrl:  sdkParams.environment === ServerEnvironment.PRODUCTION ? '//cst.innogames.de' : '//staging-cst.innogames.de',
				landingPageId: sdkParams.landingPageId,
				fileName: 'e',
				category: 'onelps',
				browser: ''
			},
			false,
			new Fingerprint({
				canvas: true
			})
		);
	} catch (err) {
		console.log('Error initialising metricsJS:');
		console.log(err);
	}

	try {
		metrics.bindPageLoadedEvent({ setParamsCookie: true });
		metrics.bindOnScrollEvent();
		metrics.bindUnloadEvent();

		document.getElementById('app').addEventListener('click', (e) => {
			if (e.target && e.target.id) {
				metrics.fireOnClickEvent(e);
			}

			if (IDS_TO_TRACK_FOCUS.includes(e.target.id)) {
				metrics.fireOnFocusEvent(e);
				metrics.bindOnBlurEvent(e.target);
			}
		});
	} catch (err) {
		console.log('Error binding metricsJS events:');
		console.log(err);
	}
}
